"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.postProcessBasket = void 0;
/**
 * Allows you to process a basket whose total is 0
 */
var postProcessBasket = function (instance) {
    return function (token, body, config) {
        return instance.post("/catalogues/baskets/".concat(token, "/process"), body, config);
    };
};
exports.postProcessBasket = postProcessBasket;
